import React, { useState, useEffect } from "react"
import { Icon } from "frontend/components/icons"
import Label from "./Label"
import styles from "./CopyableText.module.css"
import { copyText } from "frontend/utils/copy"

const CopyableText = ({ id, text, label }) => {
  const [isCopied, setCopied] = useState(false)
  let timeout = null
  const handleCopy = () => {
    copyText(text)
    setCopied(true)

    timeout = setTimeout(() => {
      setCopied(false)
    }, 1000)
  }

  useEffect(() => {
    return () => {
      clearTimeout(timeout)
    }
  }, [])
  return (
    <div className={styles.container}>
      <Label className={styles.label} id={id}>
        {label}
      </Label>
      <input data-testid="text" id={id} value={text} readOnly className={styles.text} />
      <button aria-label="copy" data-testid="copy" onClick={handleCopy} className={styles.button}>
        <Icon name={isCopied ? "check" : "copy"} isSelectable={false} />
      </button>
    </div>
  )
}

export default CopyableText
